import { useState } from "react";

export function usePagination(data, itemsPerPage = 10) {
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const sliceData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  let numbers = [];

  if (totalPages <= 5) {
    numbers = Array.from({ length: totalPages }, (_, i) => i + 1);
  } else {
    if (currentPage <= 3) {
      numbers = [1, 2, 3, "...", totalPages];
    } else if (currentPage >= totalPages - 2) {
      numbers = [1, "...", totalPages - 2, totalPages - 1, totalPages];
    } else {
      numbers = [
        1,
        "...",
        currentPage - 1,
        currentPage,
        currentPage + 1,
        "...",
        totalPages,
      ];
    }
  }

  function goToPage(page) {
    if (page === "..." || page < 1 || page > totalPages) return;
    setCurrentPage(page);
  }

  return {
    sliceData,
    currentPage,
    numbers,
    totalPages,
    goToPage,
  };
}
